import stations from "./stations.json";

const byId = new Map(stations.map((s) => [s.id, s]));

export function getStationList() {
  return stations;
}

export function getStation(stationId) {
  return byId.get(String(stationId || "").toUpperCase()) || null;
}

function distanceSq(lat1, lon1, lat2, lon2) {
  const dLat = lat1 - lat2;
  const dLon = (lon1 - lon2) * Math.cos(((lat1 + lat2) * Math.PI) / 360);
  return dLat * dLat + dLon * dLon;
}

export function findClosestStation(stationList, lat, lon) {
  if (!Number.isFinite(lat) || !Number.isFinite(lon) || !Array.isArray(stationList)) {
    return null;
  }
  let best = null;
  let bestDist = Infinity;
  for (const station of stationList) {
    if (!Number.isFinite(station?.lat) || !Number.isFinite(station?.lon)) continue;
    const dist = distanceSq(lat, lon, station.lat, station.lon);
    if (dist < bestDist) {
      bestDist = dist;
      best = station;
    }
  }
  return best;
}
